/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Recipe from './recipe';
import RecipeDetail from './recipe-detail';
import RecipeUpdate from './recipe-update';
import RecipeDeleteDialog from './recipe-delete-dialog';

const RecipeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Recipe />} />
    <Route path="new" element={<RecipeUpdate />} />
    <Route path=":id">
      <Route index element={<RecipeDetail />} />
      <Route path="edit" element={<RecipeUpdate />} />
      <Route path="delete" element={<RecipeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RecipeRoutes;
